const e = "Effacer le champ de recherche", c = "Sélectionner une option", l = {
  clearSearch: e,
  selectPlaceholder: c,
  "Select.InputSearch.Value:placeholder": "Recherche",
  "Select.InputSearch.Value:aria-label": "Recherche"
};
export {
  e as clearSearch,
  l as default,
  c as selectPlaceholder
};
